import React, { useRef, useEffect, useState } from 'react';
import { FormHandles } from '@unform/core';
import { AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, useDisclosure, Text, VStack, Button } from '@chakra-ui/react';
import * as Yup from 'yup';

import api from '../../../services/api';
import { useAuth } from '../../../hooks/auth';
import { useToast } from '../../../hooks/toast';
import getValidationErrors from '../../../utils/getValidationErrors';
import Input from '../../Inputs/Input';
import Loading from '../../Loading';
import { AppError } from '../../../utils/AppError';
import { ClassifDTO } from '../../../dtos/ClassifDTO';

import { Container,Content, Header, FormView, Buttons } from './styles';

interface ModalParams {
	onClose: any;
	isVisible: boolean;
	classif: ClassifDTO;
	fetchClassifs: () => Promise<void>;
}

const ModalClassif: React.FC<ModalParams> = ({
  onClose = () => {},
  isVisible,
	classif,
	fetchClassifs
}) => {
  const formRef = useRef<FormHandles>(null);

  const { user, company, token } = useAuth();
  const { addToast} = useToast();

  const [visible, setVisible] = useState(isVisible);
	const [loading, setLoading] = useState(true);

	const [createClassif, setCreateClassif] = useState({});

	const { isOpen, onOpen, onClose: onCloseAlert } = useDisclosure();
	const cancelRef = useRef(null);

  useEffect(() => {
		setLoading(false);
  }, []);

	async function handleCancelar() {
		formRef.current?.reset();
		setVisible(false);
		onClose();
	};

  async function handleSubmitCadastro(dataa: any) {
		try {
			setLoading(true);
			formRef.current?.setErrors({});

			const schema = Yup.object().shape({
				nome: Yup.string().required('Nome é obrigatório!'),
			});

			await schema.validate(dataa, { abortEarly: false });

			const auxClassif = {
				...dataa,
				id_emp: classif.empcod ? classif.empcod : company.id,
				id_usu: user.id,
				id: classif.id_classif ? classif.id_classif : 0
			};

			const { data } = await api.post('portal/classif', { classif: auxClassif })
				.catch((err) => {
					throw err;
				});

			if (data.che === 'N') {
				addToast({
					type: 'error',
					title: 'Classificação',
					description: data.msg,
				});
			} else {
				addToast({
					type: 'success',
					title: 'Classificação',
					description: data.msg,
				});
			}
		}
		catch (error) {
			if (error instanceof Yup.ValidationError) {
				const errors = getValidationErrors(error);
				formRef.current?.setErrors(errors);
				return;
			}

			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível criar a classificação.';

			addToast({
				type: 'error',
				title: 'Criar/Editar Classificação!',
				description: msg,
			});
		}
		finally {
			setCreateClassif({});
			setLoading(false);
			onClose();
			fetchClassifs();
		}
  };

  return (
		<>
			{loading && <Loading />}

			<Container id="ModalClassif">
				<Content className={`${visible ? 'active' : ''}`}>
					<Header>
						<h1>{classif?.nome ? classif.nome : 'Nova Classificação'}</h1>
					</Header>

					<FormView ref={formRef} onSubmit={handleSubmitCadastro} initialData={classif}>
						<div className="form-left">

							{/* DESCRIÇÃO CONTA */}
							<div className="input">
								<p>Nome classificação <span>(obrigatório)</span></p>

								<Input
									name="nome"
									type="text"
									placeholder="Nome classificação"
									containerStyle={{ padding: '5px 10px' }}
								/>
							</div>
						</div>

						<Buttons>
							<button
								type="button"
								className="button-cancel"
								// onClick={handleCancel}
								onClick={onOpen}
							>
								Cancelar
							</button>

							<button type="submit" className="button-save">
								Salvar
							</button>
						</Buttons>
					</FormView>
				</Content>
			</Container>

			<AlertDialog
				isOpen={isOpen}
				leastDestructiveRef={cancelRef}
				onClose={onCloseAlert}
				isCentered
			>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize='lg' fontWeight='bold'>
							Você não salvou suas alterações!
						</AlertDialogHeader>

						<AlertDialogBody>
							<Text fontFamily="heading">Deseja sair sem salvar?</Text>
						</AlertDialogBody>

						<AlertDialogFooter>
							<Button ref={cancelRef} onClick={onCloseAlert}>
								Cancelar
							</Button>

							<Button
								colorScheme='red'
								ml={3}
								onClick={handleCancelar}
							>
								Sair
							</Button>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
		</>
  );
};

export default ModalClassif;
